import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cn from 'classnames';
import theme from '../styles/theme';
import Caption from './Caption';
import {
  getSliceCopy,
  getSliceTitleAndTag,
} from '../selectors';

const LargeModule = ({
  children, captionClassName, className, classes, id, title, copy, ...rest
}) => (
  <div className={className} id={id}>
    {(title || copy) && (
      <Caption
        {...rest}
        classNames={{ caption: cn(captionClassName, classes.intro), copy: classes.copy }}
        title={title}
        copy={copy}
      />
    )}
    {children}
  </div>
);

LargeModule.propTypes = {
  ...Caption.propTypes,
  className: PropTypes.string,
  captionClassName: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types -- used in mapStateToProps
  sliceId: PropTypes.number.isRequired,
};

LargeModule.defaultProps = {
  ...Caption.defaultProps,
  captionClassName: undefined,
  className: undefined,
};

const mapStateToProps = (state, { sliceId }) => ({
  copy: getSliceCopy(state, sliceId),
  ...getSliceTitleAndTag(state, sliceId),
});

export default compose(
  connect(mapStateToProps),
  injectSheet({
    intro: {
      maxWidth: '100%',
      [theme.breakpoints.up('md')]: {
        maxWidth: '75%',
      },
      marginBottom: 16,
    },
    copy: {
      marginBottom: 0,
      color: theme.colors.txtPrimary,
      fontFamily: theme.fonts.body,
    },
  }),
)(LargeModule);
